import ApiClient from "../apiClient";

export interface ActiveDesk {
  id: string;
  slug: string;
  storageId: string;
  name: string;
  color: string;
  visibility: "desk" | "agent-corpus";
}

export interface ActiveDeskService {
  get: (deskId?: string) => Promise<ActiveDesk>;
}

export function createActiveDeskService(client: ApiClient): ActiveDeskService {
  return {
    async get(deskId?: string) {
      const query = deskId ? `?deskId=${encodeURIComponent(deskId)}` : "";
      const json = await client.get<{ desk: ActiveDesk }>(
        `/api/active-desk${query}`,
      );
      return json.desk;
    },
  };
}
